import React, { useCallback, useRef } from 'react';
import { FieldArray } from 'react-final-form-arrays';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';

import OnboardingWizardContentWrapper from '../OnboardingWizardWrappers/OnboardingWizardContentWrapper/OnboardingWizardContentWrapper';
import WorkspacesPreview from '../WorkspacesPreview/WorkspacesPreview';
import CheckboxItem from '../CheckboxItem/CheckboxItem';
import DiscussionTopicsListPreview from './DiscussionTopicsListPreview/DiscussionTopicsListPreview';
import { optionsDecorator, outputOptionsDecorator } from '../../utils';
import { discussionTopicOptions } from '../../constants';
import AddMoreTopicsButton from './AddMoreTopicsButton/AddMoreTopicsButton';
import { WorkspacesType } from '../../types';

import './DiscussionTopics.scss';

type Props = {
  workspaces: WorkspacesType;
  discussionTopics: Array<string>;
  advanceOnboardingState: Function;
};

function topicsValidate(values) {
  if (values.some(item => item.checked)) return undefined;
  return 'Required field';
}

function DiscussionTopics({ workspaces, discussionTopics: intitialDiscussionTopics, advanceOnboardingState }: Props) {
  const handleNextStep = useCallback(
    ({ discussionTopics }) => advanceOnboardingState({ discussion_topics: outputOptionsDecorator(discussionTopics) }),
    [advanceOnboardingState]
  );
  const ref = useRef(null);

  const handleAddMoreClick = useCallback(() => {
    const node = ref.current;
    if (node) node.focus();
  }, []);

  return (
    <OnboardingWizardContentWrapper
      initialValues={{
        workspaces,
        discussionTopics: optionsDecorator({
          options: intitialDiscussionTopics,
          presetOptions: discussionTopicOptions,
        }),
      }}
      onNextStep={handleNextStep}
      previewSectionContent={<WorkspacesPreview workspaceContent={<DiscussionTopicsListPreview />} />}
    >
      <div className="onboarding-discussion-topics scrollbar pl-1">
        <h4 className="onboarding-form-title mb-3 padding-right-50">
          Discussion Topics are like meeting agenda items. Let’s add some to all of your new workspaces.
        </h4>
        <FieldGroup
          label="What topics should we add to all of the workspaces?"
          labelClassName="onboarding-form-label pt-3 mb-3"
        >
          <div className="discussion-topics-list scrollbar padding-right-50">
            <FieldArray name="discussionTopics" validate={topicsValidate}>
              {({ fields }) =>
                fields.map((name, index) => (
                  <CheckboxItem
                    innerRef={index === fields.value.length - 1 ? ref : null}
                    index={index}
                    key={name}
                    name={name}
                    remove={fields.remove}
                    placeholder="Enter discussion topic"
                  />
                ))
              }
            </FieldArray>
          </div>
          <AddMoreTopicsButton onClick={handleAddMoreClick} />
        </FieldGroup>
      </div>
    </OnboardingWizardContentWrapper>
  );
}

export default DiscussionTopics;
